import { render, staticRenderFns } from "./dataEntryNewMain.vue?vue&type=template&id=7b81a24c&scoped=true"
import script from "./dataEntryNewMain.vue?vue&type=script&lang=js"
export * from "./dataEntryNewMain.vue?vue&type=script&lang=js"
import style0 from "./dataEntryNewMain.vue?vue&type=style&index=0&id=7b81a24c&prod&scoped=true&lang=css"
import style1 from "./dataEntryNewMain.vue?vue&type=style&index=1&id=7b81a24c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b81a24c",
  null
  
)

export default component.exports